import * as React from 'react';


import { useScreenerStore } from "../../store/screener"; 
import Tooltip from '@mui/joy/Tooltip';
import FormControl from '@mui/joy/FormControl';
import FormLabel from '@mui/joy/FormLabel';
import Select from '@mui/joy/Select';
import Option from '@mui/joy/Option'; 
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

export default function ValueareaFilter() {
    const setItemValue = useScreenerStore(state => state.setItemValue)
    let itemValue = useScreenerStore((state) => state.screenerCriteria.cclosestatus)

    const handleChange = async (event, newItemValue) => {
        console.log('newItemValue', newItemValue)
        if (itemValue == newItemValue || newItemValue == "" || newItemValue == null) {
            newItemValue = null
        }
        await setItemValue('cclosestatus', newItemValue);
    };

    //console.log('render valuearea filter')
    //console.log('itemValue', itemValue)

    if (itemValue == null) {
        itemValue = ""
    }
  
    return (
        <FormControl size="sm">
            <Tooltip title="Filter current stock price relative to the previous day's value area." variant="solid" arrow placement="top"><FormLabel>PRICE:PVA <InfoOutlinedIcon/> </FormLabel></Tooltip>
            <Select
                size="sm"
                placeholder="Filter by status"
                value={itemValue}
                onChange={handleChange}
                slotProps={{ button: { sx: { whiteSpace: "nowrap" } } }}
            >
                <Option value="">Any</Option>
                <Option value="Above PVAH">Above PVAH</Option>
                <Option value="Inside PVA">Inside PVA</Option>
                <Option value="Below PVAL">Below PVAL</Option>
            </Select>
        </FormControl>
    );
}